import React from "react";
import { Link } from "react-router-dom";

export default function TermsConditionsPage() {
  return (
    <div className="container">
      <h1>Terms and Conditions</h1>

      <p>
        These Terms of Use govern the use of any website owned or operated by
        Canon Australia Pty Limited (ABN 66 005 002 951) (“Canon”). By accessing
        or using any such website (“Site”), you agree to be bound by these Terms
        of Use. If you do not accept these Terms of Use, you must refrain from
        using the Site.
      </p>
      <h2>Personal Use of Site Only</h2>
      <p>
        Unless Canon agrees otherwise in writing, you are provided with access
        to the Site only for your personal and non-commercial purposes. You are
        authorised to print a copy of any information contained on the Site for
        your personal use, unless such printing is expressly prohibited. You may
        not, however, without our written permission, make commercial use of the
        information obtained from the Site.
      </p>
      <h2>Copyright</h2>
      <p>
        All copyright subsisting in the material on the Site (including text,
        graphics, logos, icons, sound recordings and software) is owned or
        licensed by Canon. Other than for the purposes of, and subject to the
        conditions prescribed under the Copyright Act 1968 (Cth) and similar
        legislation in other jurisdictions, and except as expressly authorised
        by these Terms of Use, you may not in any form or by any means:
      </p>
      <ul>
        <li>
          adapt, reproduce, store, distribute, print, display, perform, publish
          or create derivative works from any part of the Site; or&nbsp;
        </li>
        <li>
          otherwise commercialise any information, products or services obtained
          from any part of the Site, without Canon’s written permission, or in
          the case of third party material, from the owner of the copyright in
          the third party material.
        </li>
      </ul>
      <h2>Trade Marks</h2>
      <p>
        The trade marks used on the Site are either trade marks of Canon Inc. or
        Canon, or third party trade marks which Canon has permission to use.
        Nothing on the Site gives you any licence or right to use any trade mark
        displayed on the Site without the express written permission of Canon
        Inc. or Canon or, if applicable, the third party owner of the trade
        mark.&nbsp;
      </p>
      <h2>Links</h2>
      <p>
        The Site may contain links to web sites which are not owned or operated
        by Canon. These links are provided for convenience only and may not
        remain current or be maintained. Canon is not responsible for the
        content or privacy practices associated with the linked websites. Your
        linking to any other such website is entirely at your own risk.
      </p>
      <p>
        Unless expressed otherwise in the Site, our links to linked websites
        should not be construed as an endorsement, approval or recommendation by
        Canon of the owners or operators of those linked websites, or of any
        information, graphics, materials, products or services referred to or
        contained on those linked websites.
      </p>
      <p>If you hyperlink to the Site, you must:</p>
      <ul>
        <li>attribute Canon as the original source of the hyperlink;&nbsp;</li>
        <li>
          link to our content directly, using the title or headline of the
          content to which you are linking; and&nbsp;
        </li>
        <li>
          comply with all copyright, trade mark or other applicable intellectual
          property laws.
        </li>
      </ul>
      <h2>Privacy Policy</h2>
      <p>
        These Terms of Use must be read in conjunction with (and include) the{" "}
        <Link to="/privacy-policy">Canon Privacy Policy</Link>.
      </p>
      <h2>Trade Marks</h2>
      <p>
        User Contribution means any text, data, images, graphics, video or other
        material submitted by you in the course of your use of any Service
        available, including comments, feedbacks, ratings and reviews, images,
        videos and competition entries. By submitting a User Contribution, you
        represent and warrant that:
      </p>
      <ul>
        <li>
          (a) &nbsp; &nbsp; &nbsp;you own all rights in your User Contribution;
        </li>
        <li>
          (b) &nbsp; &nbsp; &nbsp;you are the individual pictured and/or heard
          in your User Contribution or, alternatively, you have obtained
          permission from each person (or, in the case of individuals under the
          age of 18, consent from his/her parent or guardian) to submit the User
          Contribution and grant the rights to Canon described here;
        </li>
        <li>
          (c) &nbsp; &nbsp; &nbsp;your User Contribution is your original work
          and does not infringe:
          <ol>
            <li>
              (i) &nbsp; &nbsp; &nbsp; the copyright, trademark, patent, trade
              secret or other intellectual property rights of any third
              party;&nbsp;
            </li>
            <li>
              (ii) &nbsp; &nbsp; &nbsp;privacy rights of any third party;
              or&nbsp;
            </li>
            <li>
              (iii) &nbsp; &nbsp; any other legal or moral rights of any third
              party.&nbsp;
            </li>
          </ol>
        </li>
        <li>
          (d) &nbsp; &nbsp; &nbsp;any information contained in your User
          Contribution is not known by you to be false, inaccurate or
          misleading;&nbsp;
        </li>
        <li>
          (e) &nbsp; &nbsp; &nbsp;your User Contribution does not violate any
          law;&nbsp;
        </li>
        <li>
          (f) &nbsp; &nbsp; &nbsp; your User Contribution is not, and would not
          reasonably be considered to be:&nbsp;
          <ol>
            <li>
              (i)&nbsp;&nbsp; &nbsp;&nbsp;defamatory, libellous or
              hateful;&nbsp;
            </li>
            <li>
              (ii)&nbsp;&nbsp; &nbsp;racially, ethnically, religiously or
              otherwise biased or offensive;&nbsp;
            </li>
            <li>
              (iii)&nbsp;&nbsp; unlawfully threatening or harassing to any
              individual, partnership or corporation; or&nbsp;
            </li>
            <li>(iv)&nbsp;&nbsp; vulgar, pornographic or obscene;&nbsp;</li>
          </ol>
        </li>
        <li>
          (g) &nbsp; &nbsp; &nbsp;your User Contribution does not contain any
          viruses, worms, spyware, adware or other potentially damaging programs
          or files; and&nbsp;
        </li>
        <li>
          (h) &nbsp; &nbsp; &nbsp;your User Contribution does not contain or
          constitute any unsolicited advertising.&nbsp;
        </li>
      </ul>
      <p>
        You understand and agree that your User Contribution will not be subject
        to any obligation of confidence on the part of Canon.
      </p>
      <p>
        Canon does not guarantee that you will have recourse through Canon to
        edit or delete any content you have submitted. However, Canon reserves
        the right to refuse to post or remove any User Contribution for any
        reason.
      </p>
      <h2>MyCanon</h2>
      <p>
        Certain features of the Site are limited to MyCanon members only. If you
        wish to gain access to the MyCanon features, you will be required to
        create a user account with password. In addition these Terms of Use and
        the <Link to="/privacy-policy">Privacy Policy</Link>, additional terms
        may apply which will govern your use of the MyCanon service.&nbsp;
      </p>
      <h2>Specific Disclaimers</h2>
      <p>
        Whilst Canon has no reason to believe that any information contained on
        the Site is inaccurate, Canon does not warrant the accuracy, adequacy or
        completeness of such information, nor does Canon undertake to keep the
        Site updated. Canon does not accept responsibility for loss suffered as
        a result of reliance by you upon the accuracy or currency of information
        contained on the Site.
      </p>
      <p>
        Features and specifications of products and services described or
        depicted on, or available for purchase through, the Site are subject to
        change without notice.
      </p>
      <p>
        Information on the Site has been prepared in accordance with Australian
        law and may not satisfy the laws of any other country. Canon assumes no
        responsibility, and shall not be liable, for any damage to your computer
        equipment or other property due to your access to, or use of the Site or
        your downloading of any material from the Site.
      </p>
      <p>
        Canon assumes no responsibility, and shall not be liable, for any
        interruptions or errors in access to the Site or the accuracy,
        timeliness, completeness, security or reliability of any communications
        (including, without limitation, any transactions) made through or in
        relation to the Site.
      </p>
      <p>
        Canon does not guarantee that the Site will be free from errors or
        viruses, or that access to the Site will function as intended or
        uninterrupted. You must take your own precautions to ensure that
        accessing the Site does not expose you to the risk of viruses, malicious
        computer code or other forms of interference or damage to Canon’s
        computer system which arises in connection with your use of the Site.
      </p>
      <p>
        Data transmissions over the Internet cannot be guaranteed to be totally
        secure. Whilst Canon strives to protect such information, Canon does not
        warrant and cannot ensure the security of any information which you
        transmit to Canon. Accordingly, any information which you transmit to
        Canon is transmitted at your own risk.
      </p>
      <h2>General Disclaimer and Limitation of Liability</h2>
      <p>
        Canon does not accept any responsibility for any loss or damage, however
        caused which you may directly or indirectly suffer in connection with
        your use of the Site or any linked website, nor does Canon accept any
        responsibility for any such loss arising out of your use of or reliance
        on information contained on or accessed through the Site.
      </p>
      <p>
        Subject to the applicable consumer guarantees under the Australian
        Consumer Law (ACL), and to the maximum extent permitted by law, Canon
        excludes any condition, guarantee or warranty which would otherwise be
        implied into these Terms of Use, provide that nothing in these Terms of
        Use should be interpreted as attempting to exclude these consumer
        guarantees or limit our liability for breaching the guarantees.
      </p>
      <h2>Changes to these Terms</h2>
      <p>
        Canon may change these Terms of Use from time to time as necessary. If
        Canon does so, Canon will post the revised Terms of Use on the Site.
        Canon may also give notice by other means, such as a message on the
        Site. Amendments will be effective immediately upon publication on the
        Site. Your continued use of the Site following such amendment will
        represent an agreement by you to be bound by the Terms of Use as
        amended.&nbsp;
      </p>
      <h2>Termination of Access</h2>
      <p>
        Canon may terminate access to the Site at any time without prior notice.
        In the event of termination, our specific disclaimers and general
        disclaimer and limitation of liability will survive termination.&nbsp;
      </p>
      <h2>Governing Law and Jurisdiction</h2>
      <p>
        These Terms of Use are governed by the laws in force in the State of New
        South Wales, Australia. Where permitted by law, you agree to submit to
        the exclusive jurisdiction of the courts of New South Wales and any
        courts which may hear appeals from those courts in respect of any
        proceedings in connection with these Terms of Use or the use of the
        Site.
      </p>
    </div>
  );
}
